<template>
<div>
    <div class="ibox animated fadeInRightBig">
		<div class="ibox-title">
			<h3>Novo Domínio <i class="fa fa-industry" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
		</div>
        <form id="form">
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-12">
                        <label for="name"><span class="required">*</span> Nome da Empresa</label>
                        <input type="text" class="form-control" name="name" v-model="domain.name" id="name">
                    </div>
                    <div class="form-group col-md-12">
                        <label for="tenant"><span class="required">*</span>Tenant</label>
                        <input type="text" class="form-control" name="name" v-model="domain.tenant" id="name">
                    </div>
                </div>
            </div>
            <div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/domains" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                domain: {
                    name: '',
                    tenant: '',
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const self = this;
                const api = self.$store.state.api + 'domains';

                let form  = new FormData();
                let photo = document.getElementById('photo');

                form.append('name', self.domain.name);
                form.append('tenant', self.domain.tenant);

                self.$http.post(api, form)
                    .then((response) => {
                        self.domains = response.data.data;
                        self.tableData = self.domains;

                        self.$message('Sucesso', `Domínio cadastrado com sucesso`, 'success');

                        this.$router.push('/domains');

                        self.domain = {
                            name: '',
                            tenant:'',
                        };
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Domains/Add.vue